"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudienceSelectorsButtons = void 0;
var _AudienceSelectorsButtons = require("./AudienceSelectorsButtons.styles");
var _Button = require("../../../../../UI/Button");
var _hooks = require("../../../../../hooks");
var _AudiencePicker = require("../../../AudiencePicker.labels");
var _jsxRuntime = require("react/jsx-runtime");
const AudienceSelectorsButtons = props => {
  const {
    selectedClassesIds,
    selectedGroupsIds,
    selectedStudentsIds,
    setGroupsSelectorTempData,
    setStudentsSelectorTempData,
    setViewAndIndex,
    environmentID,
    classesIds,
    groupsIds
  } = props;
  const styles = (0, _AudienceSelectorsButtons.useStyles)(props);
  const getLabel = (0, _hooks.useLabels)({
    labels: _AudiencePicker.labels
  });
  const handleClassesAndGroupsClick = () => {
    setGroupsSelectorTempData({
      selectedGroupsIds: [...(selectedGroupsIds || [])],
      selectedClassesIds: [...(selectedClassesIds || [])]
    });
    setViewAndIndex('groupsSelector', 0);
  };
  const handleStudentsClick = () => {
    setStudentsSelectorTempData({
      selectedStudentsIds: [...(selectedStudentsIds || [])],
      groupSearchText: '',
      isGroupSearchOpen: false,
      studentsSearchText: '',
      isStudentsSearchOpen: false,
      selectedGroup: environmentID ? 'all' : classesIds && classesIds.length > 0 ? classesIds[0] : groupsIds && groupsIds.length > 0 ? groupsIds[0] : ''
    });
    setViewAndIndex('studentsSelector', 0);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-AudiencePicker__audience-selectors-buttons'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.Button, {
      view: "outlined",
      color: "basic",
      shape: "roundedRectangle",
      customStyle: {
        width: '50%'
      },
      onClick: handleClassesAndGroupsClick,
      children: [getLabel('inlineTools_groupsSelector_class'), ' ', selectedClassesIds && selectedClassesIds.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: styles['cc-AudiencePicker__audience-selectors-buttons__count'],
        children: ["(", selectedClassesIds?.length, ")"]
      }), getLabel('inlineTools_groupsSelector_groups'), selectedGroupsIds && selectedGroupsIds?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: styles['cc-AudiencePicker__audience-selectors-buttons__count'],
        children: ["(", selectedGroupsIds.length, ")"]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.Button, {
      view: "outlined",
      color: "basic",
      shape: "roundedRectangle",
      customStyle: {
        width: '50%'
      },
      onClick: handleStudentsClick,
      children: [getLabel('inlineTools_studentsSelector'), ' ', selectedStudentsIds && selectedStudentsIds.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: styles['cc-AudiencePicker__audience-selectors-buttons__count'],
        children: ["(", selectedStudentsIds.length, ")"]
      })]
    })]
  });
};
exports.AudienceSelectorsButtons = AudienceSelectorsButtons;